// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"84ca3679","79":"5a6f320c","160":"2ffcff49","328":"d658247d","623":"e4dccd16","705":"e5f6afe7","787":"5e9a6a38","862":"872cebae","956":"1c0a61fa","978":"7ac0972e"}[chunkId] + ".chunk.js";
};